<template>
    <div class="checkPay">
        <van-dialog
            v-model="showDailog"
            title="请确认微信支付是否已完成"
            :show-confirm-button=false
            :show-cancel-button=false
            >
            <div  class="checkPay-dialog-orderInfo">
                  <van-cell title-class="checkPay-dialog-text" title="订单号" :value="orderCode" />
            </div>
            <div class="checkPay-dialog-content">
                <div class="checkPay-dialog-content-cell checkPay-dialog-content-cell-sure" @click="qryActivityBusinessOrderByOrderCode(false)">我已完成支付</div>
                <div class="checkPay-dialog-content-cell checkPay-dialog-content-cell-continue"  @click="qryActivityBusinessOrderByOrderCode(true)">支付遇到问题,重新支付</div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
  import {setAesString,getAesString} from "../../../config/date";
export default {
    data(){
        return{
            showDailog:false,
            orderCode:''
        }
    },
    created(){
        this.orderCode = this.$route.query.od;
        if(this.orderCode == null || this.orderCode == ''){
            this.$dialog.alert({
                message: '支付信息获取失败!'
            }).then(() => {
                //关闭窗口
            });
            return;
        }
        this.orderCode = getAesString(this.orderCode);
        if(this.orderCode == null || this.orderCode == ''){
            this.$dialog.alert({
                message: '支付信息获取失败!'
            }).then(() => {
                //关闭窗口
                
            });
            return;
        }
        this.showDailog = true;
    },
    methods:{
        //查询订单
        qryActivityBusinessOrderByOrderCode(isPay){
            var formdata = {
                service:'user.qryActiveBusinessOrder',
                orderCode:this.orderCode,
            }
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                if(res.canPay){//未支付
                    if(!isPay){//未支付确点击已完成支付
                        this.$toast.fail("您的订单未支付,请先进行支付!");
                        return;
                    }
                    sessionStorage.setItem(setAesString("business"),setAesString(JSON.stringify(res)));
                    this.$router.push({
                        path:'/abnp'
                    });
                }else{//已支付
                    this.$router.push({
                        path:'/activeBusinessPaySuccess?od='+this.orderCode
                    });
                }
            },(res)=>{
                this.$toast.fail(res.errorMsg);
            });
        }
    }
}
</script>
<style lang="less" scoped>
.van-cell__title{
    -webkit-box-flex: 0;
    -webkit-flex: 1;
    flex: 0.2 !important;
} .van-cell__value {
    -webkit-box-flex: 0;
    -webkit-flex: 1;
    flex: 0.8 !important;
}
.checkPay{
    &-dialog{
        &-orderInfo{
            margin: 20px 0px;
        }
        &-text{
            text-align: left;
            width:20px !important;
            color: #25C973;
        }
        &-content{
            margin: 10px 0px;
            text-align: center;
            &-cell{
                border-top: 0.5px solid rgb(177, 177, 177);
                &-sure{
                    padding: 10px 0px;
                    color: red;
                    font-size: 18px;
                }
                &-continue{
                    padding: 10px 0px;
                    color: gray;
                    font-size: 14px;
                }
            }
        }
    }
}

</style>